import React from "react";
import { Box } from "@mui/material";
import { GeneralPanel } from "../panel/General";
import moment from "moment";
import "moment/locale/es";
import { contentMap } from "../sharedComponents/PanelList";
import { FilterProvider } from "../../context/FilterContext";

export const ContentPanel = ({ selectedItem, token, idDocument, rol, nameDocument, onDocumentsChange }) => {
  const panels = contentMap(token, idDocument, rol, nameDocument, onDocumentsChange);

  return (
    <FilterProvider>
      <Box style={{ flexGrow: 1, overflow: "hidden", height: "100%", padding: "5px" }}>
        {panels[selectedItem] || (
          <GeneralPanel
            token={token}
            date={moment().locale("es").format("DD [de] MMMM [del] YYYY")}
            idDocument={idDocument}
            nameDocument={nameDocument}
          />
        )}
      </Box>
    </FilterProvider>
  );
};
